import "./FeeGuidelines.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import ChooseYourSeasonFlatrate from "./sections/ChooseYourSeasonFlatrate";
import CreditCardRebateZone from "./sections/CreditCardRebateZone";
import FooterInformation from "@/reusable_sections/Footer";
export default function FeeGuidelinesPage() {
  return <div>
      <NavigationHeader />
      <ChooseYourSeasonFlatrate />
      <CreditCardRebateZone />
      <FooterInformation />
    </div>;
}